module.exports = __webpack_public_path__ + "static/media/arrow_down.301118d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/arrow_down.svg
// module id = 324
// module chunks = 2